import React from "react";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import * as queryString from "../../utils/queryString";

export enum SignUpPaths {
  SIGNUP_ROOT = "/v2/sign-up",
  SIGNUP_CREATE_ACCOUNT = "/v2/sign-up/create-account",
  SIGNUP_EMAIL_VERIFICATION = "/v2/sign-up/confirm-email",
  SIGNUP_ADD_PHONE = "/v2/sign-up/add-phone",
  SIGNUP_CONFIRM_PHONE = "/v2/sign-up/confirm-phone",
  SIGNUP_CHECKPOINT = "/v2/sign-up/checkpoint",
  SIGNUP_PATIENT_DETAILS = "/v2/sign-up/patient-details",
  SIGNUP_FIND_PATIENT = "/v2/sign-up/find-patient",
  SIGNUP_CONFIRM_GP = "/v2/sign-up/confirm-gp",
  SIGNUP_NOMINATION = "/v2/sign-up/nomination",
  SIGNUP_GP_SEARCH = "/v2/sign-up/gp-search",
  SIGNUP_GP_SEARCH_CONFIRM = "/v2/sign-up/gp-search-confirm",
  SIGNUP_CONTACT_PATIENT_CARE = "/v2/sign-up/contact-patient-care",
  SIGNUP_GP_NO_THIRD_PARTY = "/v2/sign-up/gp-no-third-party",
  SIGNUP_GP_NO_EPS = "/v2/sign-up/gp-no-eps",
  SIGNUP_GP_NOT_SUPPORTED = "/v2/sign-up/gp-not-supported",
  SIGNUP_NHS_NUMBER = "/v2/sign-up/nhs-number"
}

const SignUp: React.FC<RouteComponentProps<{}>> = props => {
  const params = queryString.decode(props.history.location.search);

  return (
    <Redirect
      push={true}
      to={{
        pathname: SignUpPaths.SIGNUP_CREATE_ACCOUNT,
        search: queryString.encode(params)
      }}
    />
  );
};

export default withRouter(SignUp);
